module.exports = __webpack_public_path__ + "img/celka.bd932b50.webp";